import { cn } from "@-/com.npmjs.cn";

/** The app icon and wordmark. `inverted` frames the icon for dark (ink) surfaces. */
export function WebsiteBrand({ inverted = false }: { inverted?: boolean }) {
  return (
    <span className="inline-flex items-center gap-2.5 font-semibold tracking-[-0.02em]">
      <img
        alt=""
        className={cn("size-9 rounded-xs", inverted && "ring-1 ring-white/15")}
        height={72}
        src="/landing/haniverse-app-icon.png"
        width={72}
      />
      <span className="text-lg">Haniverse</span>
    </span>
  );
}
